import CouponApi from '@apis/coupon/CouponApi';
import queries from '@apis/queries';
import useLoading from '@hooks/ui/useLoading';
import useToast from '@hooks/ui/useToast';
import { DownloadableCouponRow } from '@models/coupon';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

function useDownloadCoupon(
    coupon: DownloadableCouponRow,
) {
    const { eventId } = coupon;
    const queryClient = useQueryClient();
    const toast = useToast();
    const { t } = useTranslation('coupon');
    const { startLoading, stopLoading } = useLoading();
    const { push } = useFlow();
    const { mutate } = useMutation({
        mutationFn: CouponApi.downloadCoupon,
        onMutate() {
            startLoading();
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: queries.coupons._def, type: 'all' })
                .finally(() => {
                    push('CouponDownloadModal', {});
                });
        },
        onError(e: AxiosError<ErrorResponse>) {
            console.error(e);
            toast.error(e.response?.data?.message || t('download.error'));
        },
        onSettled() {
            stopLoading();
        },
    });
    return () => {
        mutate(eventId);
    };
}

export default useDownloadCoupon;
